module.exports = __webpack_public_path__ + "img/cabbage-medium.30db1693.png";